import { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const getQueryParamsObject = str => {
  const params = new URLSearchParams(str || window.location.search)
  const paramsObject = {}
  for (const [key, value] of params.entries()) {
    if (value !== '') {
      paramsObject[key] = value
    }
  }
  return paramsObject
}

export const useQueryParams = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [queryParams, setQueryParams] = useState(() => getQueryParamsObject())

  const cleanQueryParams = useCallback(() => setQueryParams({}), [])

  const updateQueryParams = useCallback(
    paramsToAppend => {
      if (
        Object.keys(paramsToAppend).length === 0 ||
        location.search === `?${new URLSearchParams(paramsToAppend).toString()}`
      )
        return

      const currentParams = new URLSearchParams(location.search)

      Object.keys(paramsToAppend).forEach(paramKey => {
        currentParams.set(paramKey, paramsToAppend[paramKey])
      })

      navigate({
        pathname: location.pathname,
        search: `?${currentParams.toString()}`
      })

      setQueryParams(prevParams => ({
        ...prevParams,
        ...paramsToAppend
      }))
    },
    [location.pathname, location.search]
  )

  useEffect(() => {
    const params = getQueryParamsObject()

    setQueryParams(params)

    if (`?${new URLSearchParams(params).toString()}` === location.search) return

    navigate({
      pathname: location.pathname,
      search: `?${new URLSearchParams(params).toString()}`
    })
  }, [location.pathname, location.search])

  return { queryParams, setQueryParams: updateQueryParams, cleanQueryParams }
}
